import { render, staticRenderFns } from "./orderDeliverDetail.vue?vue&type=template&id=712c634a&scoped=true"
import script from "./orderDeliverDetail.vue?vue&type=script&lang=js"
export * from "./orderDeliverDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDeliverDetail.vue?vue&type=style&index=0&id=712c634a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c634a",
  null
  
)

export default component.exports